import { request } from '@/api/_service.js';
export function listDealerUserAddress(params) {
  return request({
    url: '/dealerUserAddress/getDealerUserAddressList',
    method: 'get',
    params: params
  });
}
export function findDealerUserAddress(params) {
  return request({
    url: '/dealerUserAddress/findDealerUserAddress',
    method: 'get',
    params: params
  });
}
export function createDealerUserAddress(data) {
  return request({
    url: '/dealerUserAddress/createDealerUserAddress',
    method: 'post',
    data: data
  });
}
export function updateDealerUserAddress(data) {
  return request({
    url: '/dealerUserAddress/updateDealerUserAddress',
    method: 'put',
    data: data
  });
}
export function deleteDealerUserAddress(data) {
  return request({
    url: '/dealerUserAddress/deleteDealerUserAddressByIds',
    method: 'delete',
    data: data
  });
}